import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const notificationBaseUrl = '/api/notifications';

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    sendContactMail: builder.mutation<{ success: boolean; message: string }, ContactSupportPayload>(
      {
        query: (body) => ({
          url: `${notificationBaseUrl}/contact-support`,
          method: 'POST',
          body,
        }),
      }
    ),
  }),
});

export const { useSendContactMailMutation } = notificationsApi;
